import { SlotGameType1_2_2Screen } from "../SlotGameType1_2_2Screen";
import { Scale} from "../.././MyHelpers";
import { IReadOnlyResourceManager, LoadingStage, ResourceManager } from "../../ResourceManager/ResourceManager";
// namespace SlotGames2 {
    export class MysticRainbowFillingPot2_2Screen extends SlotGameType1_2_2Screen {
      public override async ResourcesLoaded(loadingStage: LoadingStage, resourceManager: IReadOnlyResourceManager): Promise<void> {
       await super.ResourcesLoaded(loadingStage, resourceManager);

        if (loadingStage != LoadingStage.Games) return;
  
        //To fix title
        this.title.style.width = Scale.Wpx(1050);
        this.title.style.height = Scale.Hpx(540);
        this.title.style.left = Scale.Xpx(70);
        this.title.style.backgroundSize = "contain";
      }
    }
  // }
